@if (initialized && activeNavigationItem) {
    <div class="config-content-container surface-0">

        @switch (activeNavigationItem.action) {
            @case ('cs.ReferralType') {
                <div class="surface-0 border-round h-full">
                    <div class="grid h-full m-0">

                        <!-- Left sidebar: ReferralType selectable list -->
                        <div class="col-12 md:col-4 lg:col-3 h-full p-2 pt-0 scroll-sidebar-container">
                            @if (widgets?.referralTypeSelectableWidget) {
                                <mvs-widget
                                        [widgetData]="widgets?.referralTypeSelectableWidget.widgetData"
                                        (onObjectSelect)="onReferralTypeSelect($event)"
                                        (onObjectDeselect)="onReferralTypeDeselect()">
                                </mvs-widget>
                            }
                        </div>

                        <!-- Middle area: ReferralTypeLevel table (always rendered; filter state depends on Type selection) -->
                        <div class="col-12 md:col-4 lg:col-4 h-full p-2 pt-0 scroll-table-container">
                            @if (widgetReferralTypeLevel) {
                                <mvs-widget
                                        [widgetData]="widgetReferralTypeLevel"
                                        [importObjectContext]="importContextReferralType"
                                        (onObjectSelect)="onReferralTypeLevelSelect($event)"
                                        (onObjectDeselect)="onReferralTypeLevelDeselect()">
                                </mvs-widget>
                            }
                        </div>

                        <!-- Right area: ReferralTypeLevelOption table (always rendered; filter cascades Type → Level) -->
                        <div class="col-12 md:col-4 lg:col-5 h-full p-2 pt-0 scroll-table-container">
                            @if (widgetReferralTypeLevelOption) {
                                <mvs-widget
                                        [widgetData]="widgetReferralTypeLevelOption"
                                        [importObjectContext]="importContextReferralTypeLevel">
                                </mvs-widget>
                            }
                        </div>

                    </div>
                </div>
            }
            @case ('cs.ReferralAccess') {
                <div class="table-container scroll-table-container">
                    @if (widgets?.referralAccessWidget) {
                        <mvs-widget
                                [widgetData]="widgets?.referralAccessWidget.widgetData">
                        </mvs-widget>
                    }
                </div>
            }
        }

    </div>
}
